import styled from 'styled-components';

const StyledErrorMessage = styled.div`
  color: ${({ theme }) => theme.defaultColors.error};
`;

export default StyledErrorMessage;
